module.exports = __webpack_public_path__ + "static/media/country_ax.35002ba0.webp";